import { memo, useCallback } from 'react';
import classNames from 'classnames';

import { Category } from 'router/routes';

import { ReactComponent as ArrowDownIcon } from 'assets/images/arrow-down.svg';
import { ReactComponent as ArtworkIcon } from 'assets/images/artwork.svg';
import { ReactComponent as UsersIcon } from 'assets/images/users.svg';
// import { ReactComponent as SettingsIcon } from 'assets/images/settings.svg';

import { Company } from 'types';

import styles from './styles.module.scss';

type Props = {
  company: Company;
  expanded: boolean;
  companySelected: boolean;
  selectedCategory: Category | null;
  onCompanyClick: (companyId: number) => void;
  onCategoryClick: (companyId: number, category: Category) => void;
};

export const ListItem: React.FC<Props> = memo(function ListItem({
  company,
  expanded,
  companySelected,
  selectedCategory,
  onCompanyClick,
  onCategoryClick,
}) {
  const handleCompanyClick = useCallback(() => {
    onCompanyClick(company.id);
  }, [company.id, onCompanyClick]);

  const handleArtworksClick = useCallback(() => {
    onCategoryClick(company.id, 'artworks');
  }, [company.id, onCategoryClick]);

  const handleUsersClick = useCallback(() => {
    onCategoryClick(company.id, 'users');
  }, [company.id, onCategoryClick]);

  // const handleSettingsClick = useCallback(() => {
  //   onCategoryClick(company.id, 'settings');
  // }, [company.id, onCategoryClick]);

  return (
    <div className={classNames(styles.container, { [styles.container_expanded]: expanded })}>
      <div onClick={handleCompanyClick}>
        <p>{company.name}</p>
        <ArrowDownIcon />
      </div>
      {expanded && (
        <div className={styles.expanded_list_container}>
          <div
            onClick={handleArtworksClick}
            className={classNames({
              [styles.selected_subItem]: companySelected && selectedCategory === 'artworks',
            })}>
            <ArtworkIcon />
            <p>Artworks</p>
          </div>
          <div
            onClick={handleUsersClick}
            className={classNames({
              [styles.selected_subItem]: companySelected && selectedCategory === 'users',
            })}>
            <UsersIcon />
            <p>Users</p>
          </div>
          {/* <div
            onClick={handleSettingsClick}
            className={classNames({
              [styles.selected_subItem]: companySelected && selectedCategory === 'settings',
            })}>
            <SettingsIcon />
            <p>Settings</p>
          </div> */}
        </div>
      )}
    </div>
  );
});
